<template>
    <div class="container">
            <div class="seach-container">
                    <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">关键字</span>
                            </div>
                            <div class="form-box-item-item">
                            <el-input
                                v-model="query.keyword"
                                size="small"
                                placeholder="请输入姓名或公司名"
                            ></el-input>
                            </div>
                        </div>
                    </div>   
                        <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">状态</span>
                            </div>
                            <div class="form-box-item-item">
                            <el-select v-model="query.type" size="small" placeholder="请选择">
                                  <el-option label="待处理" value="1"></el-option>
                                  <el-option label="已处理" value="2"></el-option>
                                  <el-option label="全部"  value="3"></el-option> 
                            </el-select>
                            </div>
                        </div>
                      </div>
                     <div class="form-container">
                        <div class="form-box-item serch-operate" >
                               <el-button type="primary" size="mini" icon="el-icon-search" @click="refreshList">搜索</el-button>
                               <el-button  icon="el-icon-delete" size="mini" @click="handleEmpty">清空</el-button>

                        </div>
                    </div>
            </div>
            <div class="addBtn">
            </div>
           <el-table
                :data="tableData"
                border
                :max-height="scrollHeight"
            >
                <el-table-column
                    v-for="col in tableCols"
                    :key="col.prop"
                    :prop="col.prop"
                    :label="col.label"
                    :width="col.width"
                    :align="col.align">
                        <template #default="scope">
                            <div v-if="(scope.column.property==='Operation')">
                                <el-button
                                 icon="el-icon-info"
                                size="mini"
                                type="info"
                                @click="handleView(scope.row)">查看</el-button>
                                 <el-button
                                 v-if="(scope.row.auditBtn==true)"
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                @click="handleAudit(scope.row,1)">转贷经办</el-button>
                                <el-button
                                 v-if="(scope.row.bankBtn1==true)"
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                @click="handleBankAudit(scope.row,2)">银行初审</el-button>
                                <el-button
                                 v-if="(scope.row.bankBtn2==true)"
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                @click="handleBankAudit(scope.row,3)">银行复审</el-button>
                               <el-button
                                 v-if="(scope.row.auditBtn1==true)"
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                @click="handleBankAudit(scope.row,4)">转贷初审</el-button>

                                 <el-button
                                 v-if="(scope.row.auditBtn2==true)"
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                @click="handleBankAudit(scope.row,5)">转贷复审</el-button>
                                <el-button
                                 v-if="(scope.row.auditBtn3==true)"
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                @click="handleBankAudit(scope.row,6)">转贷终审</el-button>
                                <el-button
                                 v-if="(scope.row.Route>4&&(scope.row.State==1||scope.row.State==4||scope.row.State==2))"
                                size="mini"
                                type="warning"
                                icon="el-icon-mobile"
                                @click="handleEWM(scope.row)">二维码</el-button>
                                 <el-button
                                 v-if="(scope.row.deleteBtn==true)"
                                size="mini"
                                type="warning"
                                icon="el-icon-delete"
                                @click="handleDelete(scope.row.Id)">删除</el-button>
                                
                            </div>
                            <div v-else-if="(scope.column.property==='State')">
                                <span v-if="(scope.row.State==3)">
                                    转贷审核不通过
                                </span>
                               <span v-else-if="(scope.row.State==5)">被银行拒绝</span>
                               <span v-else-if="(scope.row.State==6)">
                                    已完成签约
                                </span>
                                <span v-else-if="(scope.row.State==7)">
                                    用户拒绝签约
                                </span>
                                <span v-else-if="(scope.row.State==8)">
                                    合同过期
                                </span>
                               <span v-else-if="(scope.row.Route==1)">
                                  <span v-if="(scope.row.ReturnReason)">被退回</span>
                                  <span v-else>已申请</span>
                               </span>
                               <span v-else-if="(scope.row.Route==2)">
                                      <span v-if="(scope.row.NewRoute==1)">已转贷初审</span>
                                      <span v-else>已转贷经办</span>
                               </span>
                               <span v-else-if="(scope.row.Route==3)">
                                      已转贷复审
                               </span>
                               <span v-else-if="(scope.row.Route==4)">
                                       已银行初审
                               </span>
                               <span v-else-if="(scope.row.Route==5)">
                                       已银行复审
                               </span>
                               <span v-else-if="(scope.row.Route==6)">
                                      已银行终审
                               </span>
                               <span v-else-if="(scope.row.Route==7)">
                                      已转贷终审
                               </span>
                               <span v-else-if="(scope.row.Route==8)">
                                      待配偶签约
                               </span>
                            </div>
                            <!-- <div v-else-if="(scope.column.property === 'Type')">
                                {{getTypeName(scope.row[scope.column.property])}}
                            </div> -->
                            <div v-else>
                                {{scope.row[scope.column.property]}}
                            </div>
                        </template>
                    </el-table-column>
            </el-table>
          <div class="pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :current-page="query.pageIndex"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="query.pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="pageTotal">
                </el-pagination>
            </div>
        <el-dialog title="二维码" v-model="ewmVisible" width="400px" top="200px">
                      <div style="margin-left: 70px;">
                            <el-select v-model="nowuser" size="small" placeholder="请选择" @change="changeEWM">
                                  <el-option label="银行" value="银行"></el-option>
                                  <el-option label="申请用户" value="申请用户"></el-option>
                                  <el-option label="用户配偶" v-if="nowdata.PersonFlag==1&&nowdata.POName" value="用户配偶"></el-option> 
                            </el-select>
                        </div>
                        <div style="margin:20px 140px 20px 140px;">
                         <el-button
                                size="mini"
                                type="primary"
                                @click="toViewSign">复制链接</el-button>
                        </div>
                       <div class="qcCodeDiv" ref="qrCodeUrl"></div>
        </el-dialog>
        <LoanAudit ref="loanAudit" ></LoanAudit>
        <LoanBankAudit ref="loanBankAudit" ></LoanBankAudit>
        <LoanDetail ref="loanDetail" ></LoanDetail>
    </div>
</template>

<script>
import indexJs from "./index.js";
  export default indexJs;
</script>

<style scoped>
.dialog-Btn{
    text-align: center;
}
 .qcCodeDiv{
    display: inline-block;
    height: 200px;
    width: 200px;
    margin-left: 80px;
    text-align: center;
    cursor: pointer;
}
</style>
